module.exports = __webpack_public_path__ + "static/media/IMG_3435.d46f5cce.JPG";